<script>
import StakeholderService from "@/services/StakeholderService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        text: {},
        defaultRows: {
            type: Number,
            default: 4
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {}
    },
    data() {
        return {
            editing: false,
            tmp_value: ""
        };
    },
    computed: {
        fieldType() {
            return "textarea";
            if (this.field == "note") {
                return "textarea";
            } else {
                return "text";
            }
        }
    },
    watch: {
        saving: function(oldV, newV) {
            if (oldV == true && newV == false && this.error !== "") {
                this.editing = true;
            }
        }
    },
    methods: {
        startEditing() {
            this.tmp_value = Cloner.clone(this.text);
            this.editing = true;
        },
        async updateField() {
            this.editing = false;
            this.$emit("save", this.tmp_value);
        }
    }
};
</script>

<template>
    <div class="v-inline-edit">
        <template v-if="editing">
            <textarea
                v-model="tmp_value"
                class="editing-element"
                :rows="defaultRows"
            ></textarea>
            <div class="alert alert-danger mt-2" v-if="error">
                {{ $t("stakeholders.general_error_update_inline") }}
            </div>
            <div class="d-flex mt-2">
                <div class="eq mr-1">
                    <base-button
                        size="sm"
                        type="danger"
                        outline
                        block
                        @click="editing = false"
                        ><i class="far fa-times"></i
                    ></base-button>
                </div>
                <div class="eq ml-1">
                    <base-button
                        size="sm"
                        type="primary"
                        outline
                        block
                        @click="updateField"
                        ><i class="far fa-save"></i
                    ></base-button>
                </div>
            </div>
        </template>
        <template v-else
            ><i v-if="saving" class="fad fa-pulse fa-spinner"></i
            ><span
                v-else
                @click="startEditing"
                style="cursor: pointer; white-space: pre-line;"
                >{{ text }}</span
            >
        </template>
    </div>
</template>

<style lang="scss">
.v-inline-edit {
    .eq {
        width: 50%;
    }

    .alert {
        font-size: 12px;
        padding: 5px;
    }

    .editing-element {
        width: 100%;
        border: 1px solid $gray-300;
        border-radius: 6px;
    }
}
</style>
